__turbopack_context__.v({
  "breakdown": "price-first-module__R-fZ-G__breakdown",
  "fields": "price-first-module__R-fZ-G__fields",
  "notice": "price-first-module__R-fZ-G__notice",
  "offer": "price-first-module__R-fZ-G__offer",
  "offerLink": "price-first-module__R-fZ-G__offerLink",
  "offers": "price-first-module__R-fZ-G__offers",
  "scenarios": "price-first-module__R-fZ-G__scenarios",
  "selection": "price-first-module__R-fZ-G__selection",
  "summary": "price-first-module__R-fZ-G__summary",
  "ticket": "price-first-module__R-fZ-G__ticket",
  "ticketBody": "price-first-module__R-fZ-G__ticketBody",
  "ticketHeader": "price-first-module__R-fZ-G__ticketHeader",
  "ticketNote": "price-first-module__R-fZ-G__ticketNote",
});
